import { render, staticRenderFns } from "./data46.vue?vue&type=template&id=c18c502e&scoped=true"
import script from "./data46.vue?vue&type=script&lang=js"
export * from "./data46.vue?vue&type=script&lang=js"
import style1 from "./data46.vue?vue&type=style&index=1&id=c18c502e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c18c502e",
  null
  
)

export default component.exports